(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-draw-error-handling.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-draw-error-handling.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const useGetCurrentWagerProductInfo = svs.components.tipsen.hooksWager.useGetCurrentWagerProductInfo;
const useDrawResults = svs.components.tipsen.hooks.useDrawResults;
const useDialog = svs.components.lbUi.betterDialog.useDialog;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _React = React,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo;
const selectDrawsRequests = svs.components.sport.drawsRedux.selectors.selectDrawsRequests;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const FetchState = svs.components.sport.drawsRedux.FetchState;
const useDrawErrorHandling = _ref => {
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    errorDestination = _ref.errorDestination,
    errorDialog = _ref.errorDialog,
    _ref$shouldRedirect = _ref.shouldRedirect,
    shouldRedirect = _ref$shouldRedirect === void 0 ? true : _ref$shouldRedirect;
  const dialogObject = useMemo(() => _objectSpread({
    icon: 'exclamation-sign',
    title: 'Just nu kan vi inte visa något resultat för denna omgång.',
    acceptText: 'Tillbaka till lobbyn'
  }, errorDialog), [errorDialog]);
  const resultErrorDialog = useDialog(dialogObject);
  const history = useHistory();
  const drawsRequests = useSelector(selectDrawsRequests);
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const drawLoadingState = drawsRequests[drawId];
  const goToErrorDestination = useCallback(() => {
    if (errorDestination && errorDestination.length > 0) {
      history.replace(errorDestination);
    } else if (shouldRedirect) {
      history.goBack();
    }
  }, [errorDestination, history, shouldRedirect]);
  const _useDrawResults = useDrawResults({
      productId,
      drawNumber
    }, {
      skip: !drawNumber || !productId
    }),
    error = _useDrawResults.error;
  useEffect(() => {
    const errorDialog = async () => {
      await resultErrorDialog.open();
      goToErrorDestination();
      await resultErrorDialog.close();
    };
    if (error && Object.keys(error).length > 0 || drawLoadingState && drawLoadingState === FetchState.Rejected) {
      errorDialog();
    }
  }, [drawLoadingState, error, goToErrorDestination, history, resultErrorDialog]);
};
const useDrawErrorHandlingWagerId = _ref2 => {
  let wagerId = _ref2.wagerId,
    errorDestination = _ref2.errorDestination,
    errorDialog = _ref2.errorDialog;
  const _useGetCurrentWagerPr = useGetCurrentWagerProductInfo({
      wagerId
    }),
    productId = _useGetCurrentWagerPr.productId,
    drawNumber = _useGetCurrentWagerPr.drawNumber;
  useDrawErrorHandling({
    drawNumber,
    productId,
    errorDestination,
    errorDialog
  });
};
setGlobal('svs.components.tipsen.hooksWager.useDrawErrorHandling', {
  useDrawErrorHandling,
  useDrawErrorHandlingWagerId
});

 })(window);